import { PROMO_CODE_MODEL_KEY } from 'models/daos/promo-code/constants'
import { toFloatFormatterUtil } from 'models/formatters/utils'
import { addDaysDatetimeUtil } from 'utils/datetime'

function expireAtBeforeSavePromoCodeUtil (value) {
  if (!value) {
    return value
  }
  return addDaysDatetimeUtil(value)
}

const PROMO_CODE_BEFORE_SAVE_HOOK = {
  [PROMO_CODE_MODEL_KEY.EXPIRE_AT]: expireAtBeforeSavePromoCodeUtil,
  [PROMO_CODE_MODEL_KEY.VALUE]: toFloatFormatterUtil
}

export {
  PROMO_CODE_BEFORE_SAVE_HOOK
}
